// extracted by mini-css-extract-plugin
export var cMarginTop = "LandingHeader-module--c-margin-top--4d35d";
export var cPadding = "LandingHeader-module--c-padding--df3f6";
export var cPaddingBottom = "LandingHeader-module--c-padding-bottom--58c47";
export var cPaddingTop = "LandingHeader-module--c-padding-top--7c0e4";
export var containerWithoutPadding = "LandingHeader-module--containerWithoutPadding--8cab7";
export var headerLogo = "LandingHeader-module--headerLogo--797b2";
export var logo = "LandingHeader-module--logo--30a52";
export var maxWidth = "LandingHeader-module--max-width--27b11";
export var open = "LandingHeader-module--open--b3524";
export var stickyHeader = "LandingHeader-module--stickyHeader--d2353";
export var toggle = "LandingHeader-module--toggle--ae976";
export var toggleBtn = "LandingHeader-module--toggleBtn--71379";
export var toggleWrapper = "LandingHeader-module--toggleWrapper--3be39";
export var whatsappWraper = "LandingHeader-module--whatsappWraper--8dcbd";